import React, { Component } from 'react'
import '../../css/style.css';
import { Link } from "react-router-dom"

class LandingHead extends Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.timeouts = [];
    }

    componentWillUnmount() {
        this.timeouts.forEach(clearTimeout);
        this.timeouts = [];
    }

    safeSetTimeout(fn, delay) {
        const id = setTimeout(() => {
            fn();
            this.timeouts = this.timeouts.filter(t => t !== id);
        }, delay);
        this.timeouts.push(id);
        return id;
    }

    componentDidMount() {
        console.log('Component mounted');
        this.initTypewriter();

        if (!window.gsap) {
            console.error('GSAP not loaded!');
            return;
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Entrance animation
        this.safeSetTimeout(() => {
            const duration = prefersReducedMotion ? 0 : 1.5;
            const tl = window.gsap.timeline({
                defaults: { duration, ease: "power2.out" }
            });

            tl.to(".hero-center-content", {
                y: 0,
                opacity: 1,
            })
            .to(".floating-card", {
                scale: 1,
                opacity: 0.8,
                stagger: prefersReducedMotion ? 0 : 0.1,
                onComplete: function() {
                    if (!prefersReducedMotion) {
                        // Start subtle floating animation once arrived
                        window.gsap.to(this.targets(), {
                            y: "random(-40, 40)",
                            x: "random(-25, 25)",
                            duration: "random(4, 6)",
                            repeat: -1,
                            yoyo: true,
                            ease: "sine.inOut"
                        });
                    }
                }
            }, "-=1");
        }, 50);
    }

    initTypewriter() {
        const words = ['Strategic', 'Innovative', 'Impactful'];
        let wordIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        const typingSpeed = 150;
        const deletingSpeed = 100;
        const pauseEnd = 2000;

        const type = () => {
            const current = words[wordIndex];
            const typingElement = document.querySelector('.typing-text');

            if (!typingElement) return;

            if (isDeleting) {
                typingElement.textContent = current.substring(0, charIndex - 1);
                charIndex--;
            } else {
                typingElement.textContent = current.substring(0, charIndex + 1);
                charIndex++;
            }

            if (!isDeleting && charIndex === current.length) {
                // Pause at end of word
                isDeleting = true;
                this.safeSetTimeout(type, pauseEnd);
                return;
            }

            if (isDeleting && charIndex === 0) {
                isDeleting = false;
                wordIndex = (wordIndex + 1) % words.length;
                this.safeSetTimeout(type, 500); // Pause before next word
                return;
            }

            this.safeSetTimeout(type, isDeleting ? deletingSpeed : typingSpeed);
        };

        type();
    }

    render() {
        const projects = [
            { id: 'sightline', title: 'ICF Sightline Homes', type: 'image', url: '/assets/img/sightline/sightline-card.webp', link: '/sightline', className: 'card-1' },
            { id: 'emailScanner', title: 'AI Email Scanner', type: 'image', url: '/assets/img/scanner/scanner-card.webp', link: '/emailScanner', className: 'card-5' },
            { id: 'ncbiVirus', title: 'NCBI Virus', type: 'image', url: '/assets/img/ncbi-virus/ncbi-virus-header.webp', link: '/ncbiVirus', className: 'card-3' },
            { id: 'NYCA', title: 'NYCA', type: 'image', url: '/assets/img/NYCA/NYCA-hero.webp', link: '/NYCA', className: 'card-2' },
            { id: 'repatriation', title: 'Repatriation', type: 'image', url: '/assets/img/repatriation/repatriation-hero.webp', link: '/repatriation', className: 'card-6' },
            { id: 'amazon', title: 'Amazon', type: 'video', url: '/assets/img/amazon/amazon-home.mp4', link: '/amazon', className: 'card-4' },
        ];

        return (
            <div className="hero-grid">
                <div className="hero-center-content">
                    <h1 className="hero-title">
                        <span className="name-highlight">Kaipeng Yu</span>
                        Designing Solutions
                        <br />
                        that are <span className="typing-text">Strategic</span>
                    </h1>
                    <Link to="/projects" className="cta-button">
                        View My Work
                    </Link>
                </div>

                <div className="floating-cards-container">
                    {projects.map((project) => (
                        <div key={project.id} className={`floating-card ${project.className}`}>
                            <Link to={project.link}>
                                <div className="card-inner">
                                    {project.type === 'video' ? (
                                        <video
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            className="card-media"
                                            aria-label={`${project.title} project video`}
                                        >
                                            <source src={process.env.PUBLIC_URL + project.url} type="video/mp4" />
                                        </video>
                                    ) : (
                                        <div
                                            className="card-media"
                                            style={{ backgroundImage: `url(${process.env.PUBLIC_URL + project.url})` }}
                                            aria-label={`${project.title} project preview`}
                                            role="img"
                                        />
                                    )}
                                    <div className="card-overlay">
                                        <h3>{project.title}</h3>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>

                <style>{`
                    .hero-grid {
                        position: relative;
                        width: 100%;
                        height: 100vh;
                        min-height: 800px;
                        background-color: #000000;
                        background-image: 
                            linear-gradient(to right, rgba(255, 255, 255, 0.15) 1px, transparent 1px);
                        background-size: 100px 1px;
                        background-position: center center;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        overflow: visible;
                        z-index: 10;
                        margin-bottom: 100px;
                    }

                    .hero-grid::before {
                        content: '';
                        position: absolute;
                        bottom: -100px;
                        left: 0;
                        width: 100%;
                        height: 100px;
                        background: #000000;
                        clip-path: polygon(0 0, 100% 0, 50% 100%);
                        background-image: 
                            linear-gradient(to right, rgba(255, 255, 255, 0.15) 1px, transparent 1px);
                        background-size: 100px 1px;
                        background-position: center center;
                        z-index: 1;
                    }

                    .hero-center-content {
                        position: relative;
                        z-index: 25;
                        text-align: center;
                        background: radial-gradient(circle at center, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 80%);
                        padding: 6rem 4rem;
                        max-width: 90vw;
                        opacity: 0;
                        transform: translateY(30px);
                    }

                    .hero-title {
                        font-family: 'Space Grotesk', sans-serif;
                        color: #ffffff;
                        font-size: clamp(1.8rem, 3.5vw, 2.8rem);
                        line-height: 1.1;
                        margin-bottom: 2.5rem;
                        font-weight: 700;
                    }

                    .name-highlight {
                        color: #ff6868;
                        font-family: "Merriweather", serif;
                        font-size: clamp(2.5rem, 6vw, 5rem);
                        display: block;
                        margin-bottom: 1.8rem;
                    }

                    .typing-text {
                        color: #2196F3;
                        border-right: 3px solid #2196F3;
                        padding-right: 8px;
                        animation: blink 0.7s infinite;
                    }

                    .cta-button {
                        display: inline-block;
                        padding: 1.2rem 3rem;
                        background: linear-gradient(45deg, #2196F3, #ECE493);
                        color: #000;
                        text-decoration: none;
                        border-radius: 50px;
                        font-size: 1.2rem;
                        font-weight: 700;
                        transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), color 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                        box-shadow: 0 10px 30px rgba(33, 150, 243, 0.3);
                    }

                    .cta-button:hover {
                        transform: scale(1.05) translateY(-5px);
                        box-shadow: 0 15px 40px rgba(33, 150, 243, 0.5);
                        color: #000 !important;
                        text-decoration: none !important;
                    }

                    .floating-cards-container {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 100%;
                        max-width: 1600px;
                        height: 100%;
                        pointer-events: none;
                        z-index: 15;
                    }

                    .floating-card {
                        position: absolute;
                        pointer-events: auto;
                        width: clamp(200px, 25vw, 350px);
                        aspect-ratio: 16/10;
                        border-radius: 20px;
                        overflow: hidden;
                        background: rgba(255, 255, 255, 0.05);
                        backdrop-filter: blur(5px);
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        transition: border-color 0.3s ease, box-shadow 0.3s ease;
                        z-index: 10;
                        opacity: 0;
                        transform: scale(0);
                    }

                    .floating-card:hover {
                        z-index: 30;
                        transform: scale(1.05) !important;
                        border-color: rgba(33, 150, 243, 0.8);
                        box-shadow: 0 20px 50px rgba(33, 150, 243, 0.3);
                    }

                    .card-inner {
                        position: relative;
                        width: 100%;
                        height: 100%;
                    }

                    .card-media {
                        width: 100%;
                        height: 100%;
                        background-size: cover;
                        background-position: center;
                        object-fit: cover;
                        opacity: 0.8; /* Increased base opacity */
                        transition: opacity 0.3s ease;
                    }

                    .floating-card:hover .card-media {
                        opacity: 1;
                    }

                    .card-overlay {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        padding: 1.2rem;
                        background: linear-gradient(transparent, rgba(0,0,0,0.9));
                        color: #fff;
                        opacity: 0;
                        transform: translateY(10px);
                        transition: opacity 0.3s ease, transform 0.3s ease;
                    }

                    .floating-card:hover .card-overlay {
                        opacity: 1;
                        transform: translateY(0);
                    }

                    .card-overlay h3 {
                        margin: 0;
                        font-size: 1rem;
                        font-weight: 600;
                    }

                    /* Individual Card Positions - Spread out around center */
                    .card-1 { top: 15%; left: 5%; }
                    .card-2 { top: 10%; right: 5%; }
                    .card-3 { bottom: 15%; left: 8%; }
                    .card-4 { bottom: 10%; right: 8%; }
                    .card-5 { top: 45%; left: 3%; }
                    .card-6 { top: 40%; right: 3%; }

                    @media (max-width: 991px) {
                        .floating-cards-container {
                            display: none;
                        }
                        
                        .hero-grid {
                            height: auto;
                            min-height: 80vh;
                            padding: 80px 20px;
                            margin-bottom: 50px;
                        }

                        .hero-grid::before {
                            bottom: -49px;
                            height: 50px;
                            background-image: none;
                        }

                        .hero-center-content {
                            padding: 2rem 1.5rem;
                        }

                        .name-highlight {
                            font-size: clamp(3rem, 10vw, 4rem);
                            margin-bottom: 0.4rem;
                        }
                    }

                    @keyframes blink {
                        0%, 100% { border-color: transparent }
                        50% { border-color: #2196F3 }
                    }
                `}</style>
            </div>
        );
    }
}

export default LandingHead